<template>
	<div>
		<!-- <nav class="navbar">
			<div class="btn-menu-toggle">
				<div class="btn btn-menu-toggle" @click="opened = !opened">
					<div class="icon icon-menu"></div>
				</div>
				<img src="@/assets/logo.png" alt="" class="logo" />
			</div>

			<div class="d-flex w-100 align-items-center justify-content-between">
				<div>
					<slot name="bar"></slot>
				</div>
				<div class="d-flex w-100 align-items-center justify-content-end">
					

					<b-dropdown block right variant="text" class="only-desktop user-dropdown">
						<template v-slot:button-content class="dropdown-user">
							<div
								class="avatar"
								:style="{
									backgroundImage: `url('${require('@/assets/img/no-avatar-image.gif')}')`,
								}"
							></div>
							<div class="username">{{ loggedUser.name }} {{ loggedUser.lastname }}</div>
						</template>
						
						<router-link tag="b-dropdown-item" to="/logout">Salir</router-link>
					</b-dropdown>
				</div>
			</div>
		</nav>

		<div class="nav-spacer"></div> -->

		<div class="sidebar-wrapper" :class="{ opened: opened }">
			<div class="head">
				<img
					v-if="loggedUser && loggedUser.account && loggedUser.account.logo"
					:src="loggedUser.account.logo"
					alt=""
					class="logo"
				/>

				<div class="user">
					<div
						class="avatar"
						:style="{
							backgroundImage: `url('${require('@/assets/img/no-avatar-image.gif')}')`
						}"
					></div>
					<div class="data">
						<div class="username">{{ loggedUser.name }} {{ loggedUser.lastname }}</div>
						<div class="account">
							{{ loggedUser.account.name }}
						</div>
					</div>
					<div>
						<b-dropdown right variant="link" no-caret>
							<template #button-content>
								<i class="fa fa-ellipsis-v"></i>
							</template>
							<b-dropdown-item disabled>Mi perfil</b-dropdown-item>
							<b-dropdown-divider></b-dropdown-divider>
							<router-link tag="b-dropdown-item" to="/logout">Salir</router-link>
						</b-dropdown>
					</div>
				</div>
			</div>

			<div>
				<CallsHistory />
			</div>

			<div class="credits">
				powered by IWTG
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex"
import CallsHistory from "@/views/calls/CallsHistory"

export default {
	name: "Navbar",
	components: {
		CallsHistory
	},
	data() {
		return {
			opened: false,
			unreadCounter: 0,
			appVersion: process.env.VUE_APP_VERSION
		}
	},
	computed: {
		...mapGetters(["loggedUser"])
	}
}
</script>
<style lang="scss">
.sidebar-wrapper {
	width: 300px;
	height: 100%;
	overflow: hidden;
	top: 0px;
	left: 0;
	z-index: 100;
	position: fixed;
	color: #000;
	background-color: #fff;
	transition: all 0.3s ease-in-out;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	border-right: 1px solid #d3d9db;
	display: flex;
	flex-direction: column;

	.credits {
		text-align: center;
		font-size: 12px;
		padding: 5px 0px;
	}
}

@media (max-width: 991px) {
	.sidebar-wrapper {
		top: 58px;
		height: calc(100% - 58px);
		left: -290px;
		-webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
		-moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
		box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
	}
}
.sidebar-wrapper.opened {
	left: 0px !important;
}

.sidebar-wrapper .head {
	height: 140px;
	font-size: 14px;
	font-weight: normal;
	line-height: 20px;
	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 16px;
	flex-shrink: 0;

	.logo {
		max-width: 150px;
		max-height: 60px;
	}

	.user {
		margin-top: 10px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.avatar {
			width: 44px;
			height: 44px;
			border-radius: 50%;
			background-size: cover;
			background-position: center center;
			background-repeat: no-repeat;
			background-color: #fff;
			margin-right: 8px;
		}
		.data {
			flex-grow: 1;
		}
		.username {
			font-size: 0.9rem;
			font-weight: 500;
			line-height: 0.8rem;
		}
		.account {
			font-size: 0.8rem;
			font-weight: 500;
			color: #10aadd;
			line-height: 0.8rem;
		}
	}
}
</style>
